import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import EmojiReactions from 'components/EmojiReactions'
import styled from 'styled-components'

const Story = ({
  tenant,
  colorMode,
  title,
  short,
  person,
  image,
  caption,
  text,
  id,
  index,
  isFeatured,
  articleId,
}: {
  tenant?: object
  colorMode?: string
  title?: string
  short?: string
  person?: string
  image?: string
  caption?: string
  text: string
  id: string
  index: number
  isFeatured: boolean
  articleId: string
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Storywrapper>
      {!isFeatured && (
        <>
          <div className='person'>{person}</div>
          <h2 style={{ marginBottom: '2rem' }}>{title}</h2>
        </>
      )}
      <div className='photo'>
        <div className='wrapper'>
          <img
            src={
              'https://storage.googleapis.com/ta-interaktiv/trennungsgeschichten/images/' +
              image
            }
            alt='foto'
          />
        </div>
        <div className='caption'>{caption}</div>
      </div>
      {isFeatured && (
        <>
          <div className='person' style={{ marginTop: '3rem' }}>
            {person}
          </div>
          <h2>{title}</h2>
        </>
      )}

      <div className='text' dangerouslySetInnerHTML={{ __html: text }} />
      {person?.includes('*') && <div className='note'>*Name geändert</div>}
      <div className='foot'>
        <EmojiReactions
          storyId={
            title
              ? title
                  .replace(/\s/g, '')
                  .replace('«', '')
                  .replace('»', '')
                  .toLowerCase()
              : 'unknown'
          }
          articleId={articleId}
          isDisplayOnly={false}
        />
      </div>
    </Storywrapper>
  )
}

const Storywrapper = styled.div`
  max-width: 626px;
  margin: 0 auto;
  padding: 4rem 1.5rem 4rem;
  color: var(--text-color);
  font-family: var(--font-sans-serif);

  .person {
    font-size: 2.2rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.9rem;
      line-height: 2.2rem;
      margin-bottom: 0.8rem;
    }
  }
  h2 {
    color: var(--red-accent);
    padding-bottom: 0.6rem;
    margin: 0.4rem 0 0.2rem;
    font-size: 2.8rem;
    line-height: 3.6rem;
    @media only screen and (max-width: 600px) {
      font-size: 2.2rem;
      line-height: 2.8rem;
    }
    font-weight: 800;
  }
  h5 {
    font-family: var(--chart-font-stack);
    font-weight: 600;
    font-size: 1.15em;
    line-height: 1.3em;
    margin: 2em 0 0.8em;
    padding: 0;
  }
  .short {
    font-size: 1.7rem;
    line-height: 2.7rem;
  }

  .photo {
    .wrapper {
      overflow: hidden;
    }
    img {
      display: block;
      width: 100%;
      height: auto;
      transition: transform 200ms ease-in;
    }
    margin-bottom: 1rem;
  }
  .illustration {
    img {
      width: 100%;
    }
    .legend {
      color: var(--gray-3);
      font-size: 1.4rem;
      line-height: 2rem;
      margin-top: 0.3rem;
      margin-bottom: 0;
    }
  }
  .caption {
    color: var(--gray-3);
    font-size: 1.4rem;
    line-height: 2rem;
    margin-top: 0.3rem;
    margin-bottom: 0;
  }
  .note {
    font-style: italic;
  }
  .foot {
    margin-top: 1.5rem;
  }
  .text {
    a:hover,
    a:link,
    a:active,
    a:visited {
      background-image: linear-gradient(90deg, #ffe462, #ffe462);
      background-repeat: repeat-x;
      background-position: bottom;
      background-size: 100% 20%;
      transition: all 0.1s ease-in-out;
      color: var(--text-color);
      background-origin: content-box;
      text-decoration: none;
    }
    a:hover {
      background-size: 100% 100%;
      color: var(--brandblue-main);
    }
    .quote:before {
      margin: 2.4rem auto 1.6rem;
      content: '';
      display: block;
      width: 4rem;
      border-bottom: 2px solid #d3343f;
    }
    .quote:after {
      margin: 1.8rem auto 2.4rem;
      content: '';
      display: block;
      width: 4rem;
      border-bottom: 2px solid #d3343f;
    }
    .quote {
      color: var(--text-color);
      font-weight: 200;
      font-size: 2.5rem;
      line-height: 3.2rem;
      text-align: center;
      margin: 1em 0;
      padding: 0 1em;
      @media screen and (max-width: 600px) {
        font-size: 2.1rem;
        line-height: 2.8rem;
        margin: 1em 0;
        padding: 0 0.8em;
      }
    }
  }
  span.mark {
    color: var(--red-dark-1);
    font-weight: 600;
    font-size: 1.2em;
  }
`

export default Story
